/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs */

const en_gc_search_guides_gridcraft_vs_excel_sources_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0: alpha status and roadmap`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sources_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0：Alpha 状态与路线图`)
};

/**
* | output |
* | --- |
* | "GridCraft v0.7.0: alpha status and roadmap" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sources_1_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sources_1_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sources_1_label(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sources_1_label(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sources_1_label as "gc.search_guides.gridcraft_vs_excel.sources.1.label" }